import React from 'react'
import styled from 'styled-components'

import { Button, Refresh2Icon } from '@blade/ui-kit'

import { TradingPairExploreItemSkeleton } from '../pair-explore-item'

type ExplorePairsEmptyProps = {
  icon: React.ReactNode
  title: string
  description: string
  retryText: string
  onRetry: () => void
}

export const ExplorePairsEmpty: React.FC<ExplorePairsEmptyProps> = ({
  icon,
  title,
  description,
  retryText,
  onRetry,
}) => {
  return (
    <Root>
      <Message>
        <IconWrapper>{icon}</IconWrapper>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <ButtonAlt
          variant="soft"
          size="xxs"
          radius="rounded"
          iconLeft={<Refresh2Icon size={12} />}
          onClick={onRetry}
        >
          {retryText}
        </ButtonAlt>
      </Message>
      <Background>
        <TradingPairExploreItemSkeleton
          disabled
          css={`
            opacity: 0.8;
          `}
        />
        <TradingPairExploreItemSkeleton
          disabled
          css={`
            opacity: 0.5;
          `}
        />
        <TradingPairExploreItemSkeleton
          disabled
          css={`
            opacity: 0.3;
          `}
        />
        <TradingPairExploreItemSkeleton
          disabled
          css={`
            opacity: 0.3;
          `}
        />
      </Background>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  min-height: 300px;
  position: relative;

  &::after {
    content: '';

    background: linear-gradient(0deg, #111 0%, rgb(0 0 0 / 0%) 100%);

    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
`

const Background = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  padding: 12px;

  display: grid;
  gap: 6px;
`

const Message = styled.div`
  color: var(--textA-10);
  display: grid;

  justify-items: center;
  min-width: 230px;

  place-content: center;
  z-index: 1;
`

const IconWrapper = styled.div`
  height: 26px;
`

const Title = styled.div`
  color: var(--text-10);
  font-weight: 600;
  font-size: 14px;

  text-align: center;
  line-height: 20px;
  margin-top: 4px;
`

const Description = styled.p`
  color: var(--text-8);
  text-align: center;

  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`

const ButtonAlt = styled(Button)`
  --button-radius-rounded: 6px;
  color: var(--text-12);

  padding-inline: 8px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 10px;

  margin-top: 14px;
`
